import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Fade the brand splash once React has painted the first frame.
// Keep a 350ms minimum so the splash never blinks on fast networks.
(() => {
  const splash = document.getElementById('rastyle-splash');
  if (!splash) return;
  const MIN_MS = 350;
  const t0 = performance.now();
  const hide = () => {
    const wait = Math.max(0, MIN_MS - (performance.now() - t0));
    setTimeout(() => {
      splash.setAttribute('data-hide', 'true');
      // Keep the node in the DOM (just hidden) so admin uploads can still
      // swap splash <img src> live for the next launch.
    }, wait);
  };
  if (document.readyState === 'complete') {
    requestAnimationFrame(() => requestAnimationFrame(hide));
  } else {
    window.addEventListener('load', () => requestAnimationFrame(() => requestAnimationFrame(hide)), { once: true });
  }
  // Safety net: never leave the splash up for >5s even if something stalls.
  setTimeout(() => splash.setAttribute('data-hide', 'true'), 5000);
})();

// Register service worker (PWA support) — production only, never in dev to avoid
// stale hot-reload caches. Auto-prompts the user when a new bundle is available
// after a deploy, fixing the "site stuck on blank page until I clear cache" bug.
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((reg) => {
        // Check for updates every 60s (cheap, just a HEAD request)
        setInterval(() => reg.update().catch(() => {}), 60 * 1000);

        // When a new SW arrives, ask it to take over and reload the page so
        // the user gets the latest JS bundle automatically — no manual cache
        // clear needed. Only triggers AFTER first install (controller exists).
        reg.addEventListener('updatefound', () => {
          const installing = reg.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              // A new bundle is ready — activate and reload.
              installing.postMessage('SKIP_WAITING');
            }
          });
        });
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.warn('SW registration failed', err);
      });

    // When the controller changes (new SW took over), reload once to pick
    // up the new bundle. The `reloaded` flag avoids reload loops.
    let reloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}
